import React from "react";
import {
  COLUMNAS_DETALLE,
  detalleTicket,
  celdaTexto,
  formatearCantidad,
  formatearMonto,
} from "./detalleNotaEntrega";

/*
 * Tabla del detalle de una nota de entrega en forma de "ticket": una linea por
 * producto con su codigo, nombre, cantidad, precio unitario, IVA e importe, y
 * al pie los totales.
 *
 * Se usa en el modal de auditoria (pestaña "Datos Eliminados") para mostrar el
 * detalle del respaldo de la nota. El mismo criterio de columnas lo replica el
 * reporte PDF (reporteNotaEntregaRespaldoPDF).
 */
/* Alineacion Bootstrap del texto de la columna */
const alinear = (columna) =>
  "text-" + (columna.align === "right" ? "end" : "start");

export const TablaDetalleNota = (props) => {
  const { detalle, vacio } = props;
  const { filas, totales } = detalleTicket(detalle);

  if (filas.length === 0) {
    return (
      <div className="aud-ticket-vacio">
        <i className="far fa-file me-1"></i>
        {vacio || "La nota no tiene renglones para mostrar."}
      </div>
    );
  }

  return (
    <div className="aud-ticket-tabla-wrap">
      <table className="aud-ticket-tabla">
        <colgroup>
          {COLUMNAS_DETALLE.map((columna, indice) => (
            <col key={indice} className={`aud-col-${columna.key}`} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {COLUMNAS_DETALLE.map((columna, indice) => (
              <th key={indice} className={alinear(columna)}>
                {columna.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filas.map((fila, indice) => (
            <tr key={indice}>
              {COLUMNAS_DETALLE.map((columna, posicion) => (
                <td
                  key={posicion}
                  className={`${alinear(columna)} ${
                    columna.key === "producto" ? "aud-ticket-producto" : ""
                  }`}
                >
                  {celdaTexto(columna, fila)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className="text-start fw-bold" colSpan="2">
              Total ({filas.length} renglón{filas.length === 1 ? "" : "es"})
            </td>
            <td className="text-end fw-bold">
              {formatearCantidad(totales.cantidad)}
            </td>
            <td className="text-end"></td>
            <td className="text-end"></td>
            <td className="text-end fw-bold">{formatearMonto(totales.importe)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaDetalleNota.js